import ExternalLink from 'components/UI/ExternalLink'
import Svg from 'components/UI/SVG'
import { Flex, get, Text } from 'theme-ui'
import LinkIcon from 'images/desktop-download-icon.svg'

export default function DownloadOption({
  name,
  downloadUrl,
  downloadTranslation,
}: {
  name: string
  downloadUrl: string
  downloadTranslation: string
}): JSX.Element {
  return (
    <>
      <ExternalLink
        sxx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          ': hover': {
            cursor: 'pointer',
            '& span': {
              color: 'white',
            },
            '& svg path': {
              opacity: 1,
            },
          },
        }}
        href={downloadUrl}
      >
        <Text
          sx={{
            color: 'white',
            fontSize: '1.6rem',
            wordBreak: 'break-word',
            flex: '1 1 auto',
            minWidth: 0,
          }}
        >
          {name}
        </Text>
        <Flex sx={{ alignItems: 'center', flex: '0 0 auto' }}>
          <Flex
            sx={{
              display: 'flex',
              gap: '0.8rem',
              alignItems: 'center',
              'span, svg path': {
                transition: theme => `${get(theme, 'transitions.default')}`,
              },
              pl: '1.6rem',
            }}
          >
            <Text color="white50" sx={{ whiteSpace: 'nowrap' }}>
              {downloadTranslation}
            </Text>
            <Svg
              svg={LinkIcon}
              sx={{
                '& path': {
                  fill: 'white',
                },
                minWidth: '1.6rem',
                minHeight: '1.6rem',
              }}
            />
          </Flex>
        </Flex>
      </ExternalLink>
      <div sx={{ width: '100%', height: '0.2rem', backgroundColor: 'white10', my: '0.8rem' }} />
    </>
  )
}
